export default __webpack_public_path__ + "static/media/apple-login.42d160e1.svg";